import { computed, type Ref, unref } from 'vue';
import type { User } from '@keyvue/one-api-client';
import { MentionAPI, type Comment as LegacyComment, User as LegacyUser } from '@keyvue/one-api-client-legacy';
import type { Mentionable } from '@keyvue/one-ui';

export default function useMentionable(mentionableUsers: User[] | Ref<User[]>) {
    const mentionables = computed((): Mentionable[] => {
        const users = unref(mentionableUsers);

        return users.map((user) => ({
            id: user.id.value,
            name: user.name.fullName,
            type: 'user',
            data: user,
            groupByValue: user.company?.name ?? 'Gebruikers',
        }));
    });

    const mention = async (comment: LegacyComment) => {
        const users = unref(mentionableUsers);

        const mentionedUsers = users
            .filter((user) => comment.comment.indexOf(`data-id="${user.id}"`) >= 0)
            .map((user) => LegacyUser.fromOne(user));

        await MentionAPI.mention(comment, mentionedUsers);
    };

    return {
        mentionableUsers,
        mentionables,
        mention,
    };
}
